import { createContext } from 'react';

const StationContext = createContext();

export default StationContext;
